// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__2OhQq","aboutAllBlock":"about_aboutAllBlock__30iPR"};